import React, {Fragment, useContext} from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid"
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";
import {InvitesContext} from "../context/InvitesContext";
import {handleChangeFactory} from "../utils/EventHandlerUtils";

export default function EventLocationDetails(props) {
  const { classes } = props;
  const invitesContext = useContext(InvitesContext);
  const handleChange = handleChangeFactory(invitesContext.dispatch);

  const handleEventStartDateTime = (date) => {
    invitesContext.dispatch({ type: "CHANGE_VALUE", name: "eventStartDateTime", value: date });
    invitesContext.dispatch({ type: "CHANGE_VALUE", name: "eventStartDateTimeTimestamp", value: Math.round(date.getTime()/1000) });
  }

  return (
    <Fragment>
      <Grid container spacing={2} noValidate className={classes.inputContainer}>
        <Grid item xs={12} className={classes.noPadding}>
          <Paper square elevation={0} className={classes.inputTitleContainer}>
            <Typography className={classes.inputTitleText}>Locație *</Typography>
          </Paper>
            <TextField
                fullWidth
                className={classes.inputFieldContainer}
                margin="normal"
                name="locationName"
                placeholder="Ex: Imperial Ballrooms"
                onChange={handleChange}
                defaultValue={invitesContext.state.invite.locationName}
            />
        </Grid>
        <Grid item xs={12} className={classes.noPadding}>
          <Paper square elevation={0} className={classes.inputTitleContainer}>
              <Typography className={classes.inputTitleText}>Data și ora evenimentului</Typography>
            </Paper>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDateTimePicker
                fullWidth
                className={classes.inputFieldContainer}
                margin="normal"
                ampm={false}
                format="dd-MM-Y HH:mm"
                value={invitesContext.state.invite.eventStartDateTime}
                onChange={handleEventStartDateTime}
                name="eventStartDateTime"
                cancelLabel="Anuleaza"
                placeholder={"Selecteaza"}
                InputProps={{ readOnly: true }}
                minDate={new Date()}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} className={classes.noPadding}>
          <Paper square elevation={0} className={classes.inputTitleContainer}>
            <Typography className={classes.inputTitleText}>Adresa</Typography>
          </Paper>
          <TextField
            fullWidth
            className={classes.inputFieldContainer}
            name="locationAddress"
            placeholder="Ex. Șoseaua Pipera, Strada Avionului 9, București"
            onChange={handleChange}
            defaultValue={invitesContext.state.invite.locationAddress}
          />
        </Grid>
      </Grid>
    </Fragment>
  )
}